<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/loadingorder/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo.src" :height="logo.height"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Order Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.loadingordernum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.loadingorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">{{ initvalue.loadingordertype }}</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Location</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationname'] : '' }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.loadingordername }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Vehicle</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  vehicles.length>0 ? vehicles.find(vehicle=>vehicle._id == initvalue.vehicleid)['vehiclecode'] : ''  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Driver</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.length>0 ? users.find(user=>user._id == initvalue.driverid)['username'] : ''  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Loader</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.length>0 ? users.find(user=>user._id == initvalue.loaderid)['username'] : ''  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Status</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.loadingorderstatus }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </v-row>
                <p v-if="initvalue.transactions.filter(trans=>trans.transtype=='Loading').length>0" style="margin-top: 0px; margin-bottom: 5px; font-size: 14pt; font-weight: bold;">Loading</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 12%;">Quantity</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Pieces</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Weight</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Volume</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in getLoadingList()"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ items.length>0 ? items.find(item=>item._id == trans.itemid)['itemname'] : '' }}</td>
                          <td>{{ getQuantity(trans.itemid, trans.itemquantity) }}</td>
                          <td>{{ getPieces(trans.itemid, trans.itemquantity) }}</td>
                          <td>{{ trans.itemweight.toFixed(3) }}</td>
                          <td>{{ trans.itemvolume.toFixed(3) }}</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>{{ getLoadingList().reduce((a, b) => a + getQuantity(b.itemid, b.itemquantity), 0) }}</td>
                          <td>{{ getLoadingList().reduce((a, b) => a + getPieces(b.itemid, b.itemquantity), 0) }}</td>
                          <td>{{ initvalue.orderweight.toFixed(3)  }}</td>
                          <td>{{ initvalue.ordervolume.toFixed(3) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div>&nbsp;</div>
                <table v-if="initvalue.loadingorderstatus=='Unloaded'" style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th colspan="2" style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;"><p style="margin-top: 0px; margin-bottom: 5px; font-size: 14pt; font-weight: bold;">Unloading</p></th>
                      <th colspan="2" style="text-align: center; border-left: 1px; border-right: 1px; border-bottom: 1px; border-bottom-style: solid; width: 12%;">System Count</th>
                      <th colspan="2" style="text-align: center; border-left: 1px; border-right: 1px; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Physical Count</th>
                      <th colspan="2" style="text-align: center; border-left: 1px; border-right: 1px; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Difference</th>
                    </tr>
                    <tr>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2; border-left: 1px; border-left-style: solid;">#</th>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; border-right: 1px; border-right-style: solid;">Item</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 12%;">Qty</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 10%;border-right: 1px; border-right-style: solid;">Pcs</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Qty</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 10%;border-right: 1px; border-right-style: solid;">Pcs</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Qty</th>
                        <th style="text-align: center; border-bottom: 1px; border-bottom-style: solid; width: 10%;border-right: 1px; border-right-style: solid;">Pcs</th>
                      </tr>
                    </thead>
                    <tbody>

                      <tr v-for="(trans, index) in getLoadingList()"  v-bind:key="trans._id">
                          <td style="border-left: 1px; border-left-style: solid;">{{ index + 1 }}</td>
                          <td style="border-right: 1px; border-right-style: solid;">{{ items.length>0 ? items.find(item=>item._id == trans.itemid)['itemname'] : '' }}</td>
                          <td style="text-align: center;">{{ getQuantity(trans.itemid, trans.itemquantity - getSalesQuantity(trans.itemid)) }}</td>
                          <td style="text-align: center; border-right: 1px; border-right-style: solid;">{{ getPieces(trans.itemid, trans.itemquantity - getSalesQuantity(trans.itemid)) }}</td>
                          <td style="text-align: center;">{{ getQuantity(trans.itemid,  getUnloadingQuantity(trans.itemid) ) }}</td>
                          <td style="text-align: center; border-right: 1px; border-right-style: solid;">{{ getPieces(trans.itemid,  getUnloadingQuantity(trans.itemid) ) }}</td>
                          <td style="text-align: center;">{{ getQuantity(trans.itemid, (trans.itemquantity - getSalesQuantity(trans.itemid)) - (getUnloadingQuantity(trans.itemid))) }}</td>
                          <td style="text-align: center; border-right: 1px; border-right-style: solid;">{{ getPieces(trans.itemid, (trans.itemquantity - getSalesQuantity(trans.itemid)) - (getUnloadingQuantity(trans.itemid))) }}</td>
                        </tr>
                        <tr><td colspan="8" style="border-top: 1px; border-top-style: solid">&nbsp;</td></tr>
                    </tbody>
                </table>
                <p v-if="initvalue.sales.length>0" style="margin-top: 0px; margin-bottom: 5px; font-size: 14pt; font-weight: bold;">Sales Orders</p>
                <table v-if="initvalue.sales.length>0" style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 12%;">Quantity</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Pieces</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Weight</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 10%;">Volume</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(trans, index) in initvalue.sales"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ items.length>0 ? items.find(item=>item._id == trans.itemid)['itemname'] : '' }}</td>
                          <td>{{ getQuantity(trans.itemid, trans.quantity) }}</td>
                          <td>{{ getPieces(trans.itemid, trans.quantity) }}</td>
                          <td>{{ (trans.quantity * getWeight(trans.itemid)).toFixed(3) }}</td>
                          <td>{{ (trans.quantity * getVolume(trans.itemid)).toFixed(3) }}</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>{{ this.initvalue.sales.reduce((a, b) => a + getQuantity(b.itemid, b.quantity), 0) }}</td>
                          <td>{{ this.initvalue.sales.reduce((a, b) => a + getPieces(b.itemid, b.quantity), 0) }}</td>
                          <td>{{ (this.initvalue.sales.reduce((a, b) => a + (b.quantity * getWeight(b.itemid)), 0)).toFixed(3) }}</td>
                          <td>{{ (this.initvalue.sales.reduce((a, b) => a + (b.quantity * getVolume(b.itemid)), 0)).toFixed(3) }}</td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 50px">&nbsp;</p>
                <table style="width: 50%" cellpadding="0" cellspacing="0">
                <tr><td style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td><td></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';

    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        methods: {
          ...mapActions('Item', ['getItemsRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Vehicle', ['getVehiclesRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          groupBy(array) {
            var result = [];
            array.reduce(function(res, value) {
              if (!res[value.itemid]) {
                res[value.itemid] = { itemid: value.itemid, itemquantity: 0, itemweight: 0, itemvolume: 0 };
                result.push(res[value.itemid])
              }
              res[value.itemid].itemquantity += value.itemquantity;
              res[value.itemid].itemweight += value.itemweight;
              res[value.itemid].itemvolume += value.itemvolume;
              return res;
            }, {});
            return result;
          },
          groupBy2(array) {
            var result = [];
            array.reduce(function(res, value) {
              if (!res[value.itemid]) {
                res[value.itemid] = { itemid: value.itemid, quantity: 0, weight: 0, volume: 0 };
                result.push(res[value.itemid])
              }
              res[value.itemid].quantity += value.unloadQty;
              res[value.itemid].weight += value.unloadWgt;
              res[value.itemid].volume += value.unloadVol;
              return res;
            }, {});
            return result;
          },
          getLoadingList(){
            let transactions = this.initvalue.transactions.filter(trans=>trans.transtype=='Loading');
            let group = this.groupBy(transactions);
            return group;
          },
          getUnloadingList(){
            let transactions = this.initvalue.transactions.filter(trans=>trans.transtype=='Unloading');
            console.log("1", transactions)
            let group = this.groupBy2(transactions);
            console.log("2", group)
            return group;
          },
          getUnloadingQuantity(itemid){
            let list = this.getUnloadingList();
            let find = list.find(x=>x.itemid==itemid);
            return find.quantity;
          },
          getSalesQuantity(itemid){
            let item = this.initvalue.sales.find(item=>item._id==itemid);
            if(item==null) return 0;
            let result = item.quantity!=null ? item.quantity : 0;
            return result;
          },
          getQuantity(itemid, qty){
            let item = this.items.find((x) => x._id == itemid);
            if(item==null) return 0;
            let pieces = qty % 1;
            let itemquantity = (qty - pieces);
            return Math.round(itemquantity);          
          },
          getPieces(itemid, qty){
            let item = this.items.find((x) => x._id == itemid);
            if(item==null) return 0;
            let pieces = qty % 1;
            let itempieces = (pieces * item.itemconvert);
            return Math.round(itempieces);          
          },
          getWeight(itemid){
            let item = this.items.find(item=>item._id==itemid);
            if(item==null) return 0;
            let result = item.itemweight!=null ? item.itemweight : 0;
            return result;
          },
          getVolume(itemid){
            let item = this.items.find(item=>item._id==itemid);
            if(item==null) return 0;
            let result = item.itemvolume!=null ? item.itemvolume : 0;
            return result;
          },
        },
        computed: {
          ...mapState('Item', ['items']),
          ...mapState('Location', ['locations']),
          ...mapState('User', ['users']),
          ...mapState('Vehicle', ['vehicles']),
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid); 
          if(!this.initvalue._id) this.$router.push({ name: 'LoadingOrderList' });
          console.log(this.initvalue)
          if(this.items.length==0) await this.getItemsRequest(); 
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.users.length==0) await this.getUsersRequest(); 
          if(this.vehicles.length==0) await this.getVehiclesRequest(); 
            
          
        },
        mounted(){
          this.getLoadingList();
        }
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
